import { type FragmentType, graphql, useFragment } from '@typings/gql'
import { Link as GatsbyLink } from 'gatsby'
import React from 'react'

import {
  inbentaProductCategories,
  inbentaSearchCategoryMapping,
} from '../../../../static-asset/static-assets.interface'
import { useInbentaSearchItemTracking } from '../tracking-utils'

type ProductRowProps = {
  content: FragmentType<typeof ProductRowFragment>
  searchCode: string
}

export const ProductRow = ({ content, searchCode }: ProductRowProps) => {
  const {
    title,
    url,
    tracking: { clickCode, externalCode },
  } = useFragment(ProductRowFragment, content)

  const sendTrackingEvent = useInbentaSearchItemTracking(
    searchCode,
    clickCode,
    externalCode
  )

  const productCategory = (resultUrl: string) => {
    const productCategory = Object.values(inbentaProductCategories).find(
      (categorySlug) => resultUrl?.startsWith(`/${categorySlug}`)
    )
    if (!productCategory) return null

    return inbentaSearchCategoryMapping[productCategory]
  }

  return (
    <GatsbyLink
      className="flex flex-col hover:cursor-pointer hover:opacity-60"
      to={url}
      onClick={() => {
        void sendTrackingEvent()
      }}
    >
      <span className="text-100 !font-normal text-amplification-black-premium group-[.is-dark-mode]/menu:text-white-50">
        {productCategory(url)}
      </span>
      <span className="text-085 !font-normal text-amplification-black-premium/60 group-[.is-dark-mode]/menu:text-white-50/60">
        {title}
      </span>
    </GatsbyLink>
  )
}

export const ProductRowFragment = graphql(`
  fragment ProductRow on InbentaSearchItem {
    __typename
    title
    tracking {
      clickCode
      externalCode
      rateCode
    }
    url
  }
`)
